import CustomToggle from "@/components/elements/AccordionsToggles/CustomToggle";
import { useTranslation } from "next-i18next";
// COMPONENTS
import MoreDetailsTable from "./MoreDetailsTable/MoreDetailsTable";
import { useState } from "react";
// BOOTSTRAP
import Badge from "react-bootstrap/Badge";
// ICONS
import { ChevronDownIcon, ChevronUpIcon } from "@/public/icons/icons";
// BOOTSTRAP
import Accordion from "react-bootstrap/Accordion";
// STYLE
import s from "./MoreDetailsPanel.module.scss";

export default function MoreDetailsPanel({ cartMode, quantityPerSize, setQuantityPerSize, price, totalQuantity, product, modifyQuantity, variant }) {
  const { t } = useTranslation("common");

  const [accordionOpen, setAccordionOpen] = useState(false);

  return (
    <div className={`${s.panel_wrapper}`}>
      <Accordion style={{ width: "100%", alignItems: "flex-end", display: "flex", flexDirection: "column" }}>
        {quantityPerSize.length > 0 ? (
          <CustomToggle
            eventKey="0"
            className={`d-flex align-items-center justify-content-end fs-7 pt-0 ${s.more_details_button}`}
            open={accordionOpen}
            setOpen={setAccordionOpen}
            size="sm"
            variant="dark"
          >
            <div className="d-flex align-items-baseline k">
              <Badge bg="light" className="me-2">
                <span className="text-black">{quantityPerSize.length !== 0 && quantityPerSize.length}</span>
              </Badge>
            </div>
            {accordionOpen ? (
              <div>
                {t("common.hide-details")}
                <ChevronUpIcon height="20" width="20" color="white" />
              </div>
            ) : (
              <div>
                {t("common.show-details")}
                <ChevronDownIcon height="20" width="20" color="white" />
              </div>
            )}
          </CustomToggle>
        ) : null}
        <Accordion.Collapse eventKey="0" style={{ width: "100%" }}>
          <MoreDetailsTable
            cartMode={cartMode}
            modifyQuantity={modifyQuantity}
            quantityPerSize={quantityPerSize}
            setQuantityPerSize={setQuantityPerSize}
            product={product}
            price={price}
            variant={variant}
          />
        </Accordion.Collapse>
      </Accordion>
    </div>
  );
}
